/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AppointmentSortFieldV1 {
    TITLE = 'TITLE',
    TYPE = 'TYPE',
    STATUS = 'STATUS',
    CREATED_BY = 'CREATED_BY',
    CREATED_AT = 'CREATED_AT',
    PARTICIPANTS = 'PARTICIPANTS',
    START_TIMESTAMP = 'START_TIMESTAMP',
    END_TIMESTAMP = 'END_TIMESTAMP',
    EVENT_ID = 'EVENT_ID',
    LOCATION_TYPE = 'LOCATION_TYPE',
    LOCATION_REF = 'LOCATION_REF',
    REQUEST_WINDOW_START = 'REQUEST_WINDOW_START',
    REQUEST_REPEAT_INDEX = 'REQUEST_REPEAT_INDEX',
    REFS_KEY = 'REFS_KEY',
    REFS_VALUE = 'REFS_VALUE',
}